import { auth, signOut as firebaseSignOut } from 'config/firebase';
import { store } from 'store';
import { signOut } from 'store/user';
import { clearError, setAlert } from 'store/error';

// The server answers 401 with this code when the request's login was revoked by a
// password or email change (server/Prestige/firebase_revocation.py).
const SESSION_REVOKED_CODE = 'session_revoked';

let endingSession = false;
let ownLoginChangeUntil = 0;

// Call before the student changes their own password. That revokes their current
// login on purpose and the page signs straight back in, so for a short window a
// request still carrying the old token must not sign the fresh session out.
export const expectOwnLoginChange = () => {
    ownLoginChangeUntil = Date.now() + 15_000;
};

export const isSessionRevoked = (error): boolean =>
    error?.response?.status === 401 && error.response.data?.code === SESSION_REVOKED_CODE;

// End the Firebase session and land on the sign-in form with the server's message.
// The alert goes last (after clearError) so the caller's own catch, which runs
// first and may set an error status, can't leave the app on the Unauthorized page.
export const endRevokedSession = (error) => {
    if (endingSession || Date.now() < ownLoginChangeUntil) return;
    endingSession = true;

    firebaseSignOut(auth)
        .catch(() => {})
        .finally(() => {
            store.dispatch(signOut());
            store.dispatch(clearError());
            store.dispatch(setAlert(error));
            endingSession = false;
        });
};
